export default __webpack_public_path__ + "static/media/type_video.df3a8d23.svg";